<div class="container">
    <div class="most_popular py-5">

    <div class="row" >
        <div class="col-lg-4 mb-3 cursor-pointer" *ngFor="let d of lstBraches;let ind =index" (click)="branchClick(d,ind)" >
        <div class="list-card bg-white h-100 rounded overflow-hidden position-relative shadow-sm grid-card">
        <div class="list-card-image">
       
       
       
        </div>
        <div class="p-3 position-relative">
            <div class="row">
                <div class="col-md-10">
                    <div class="list-card-body">
                        <h6 class="mb-1"><a (click)="getRestaurantTime(ind)" class="text-black font-weight-bold">{{d.Name}}</a></h6>
                        <p class="text-gray mb-3">{{d.Address}}<br *ngIf="d.Address!=''">Contact No:{{d.ContactNo}}<br>Email:{{d.Email}}</p>
                       
                        <p class="text-gray mb-3 time"><span class="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i class="feather-clock"></i>{{getRestaurantTime(ind)}}</span> <span class="float-right text-black-50"> $250 FOR TWO</span></p>
                        </div>
                </div>

                <div class="col-md-2">
                    <div class="list-card-badge">
                        <i class="feather-arrow-right"></i>
                    </div>
                </div>
            </div>
        
      
        </div>
        </div>
        </div>
        
        </div>
    </div>
</div>